export const Spinner = () => {
    return (
        <div className="spinner"></div>
    );
};
